import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";
import { fetchMe } from "@/lib/api";

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    const isLogin = location.pathname === "/login";
    const user = await fetchMe();
    if (!user && !isLogin) {
      throw redirect({ to: "/login" });
    }
    if (user && isLogin) {
      throw redirect({ to: "/" });
    }
    return { user };
  },
  component: RootLayout,
});

function RootLayout() {
  return <Outlet />;
}
